import { assertNever } from '@kofno/piper';
import { Maybe, just, nothing } from 'maybeasy';
import { action, computed, makeObservable, observable } from 'mobx';
import ParticipantsStore from '..';
import { error } from '../../ErrorHandling';
import { FlashAlert, errorAlert } from '../../Notifications/Types';
import { TPlainTextKey } from '../../Translations';
import { ParticipantsOptionsResource, State, ready, waiting } from './Types';

class ParticipantsOptionsStore {
  @observable private _state: State = waiting();

  readonly participantsStore: ParticipantsStore;

  constructor(participantsStore: ParticipantsStore) {
    makeObservable(this);
    this.participantsStore = participantsStore;
  }

  @action
  ready = (resource: ParticipantsOptionsResource) => {
    this._state = ready(resource);
  };

  @action
  error = (msg: TPlainTextKey) => {
    this._state = error(msg);
  };

  @computed
  get state(): State {
    switch (this._state.kind) {
      case 'waiting':
        return this.participantsStore.state.kind === 'ready'
          ? { kind: 'loading', links: this.participantsStore.state.resource.links }
          : this._state;
      case 'ready':
      case 'error':
      case 'loading':
        return this._state;
      default:
        return assertNever(this._state);
    }
  }

  @computed
  get notification(): Maybe<FlashAlert> {
    switch (this.state.kind) {
      case 'error':
        return just(this.state).map(errorAlert);
      case 'ready':
      case 'loading':
      case 'waiting':
        return nothing();
    }
  }
}

export default ParticipantsOptionsStore;
